import { render } from "./OrderMain.vue?vue&type=template&id=7938529f&scoped=true"
import script from "./OrderMain.vue?vue&type=script&lang=js"
export * from "./OrderMain.vue?vue&type=script&lang=js"

import "@/assets/css/style.css?vue&type=style&index=0&id=7938529f&scoped=true&lang=css&external"
import "./OrderMain.vue?vue&type=style&index=1&id=7938529f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7938529f"]])

export default __exports__